var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container power-box" }, [
    _c(
      "div",
      { staticClass: "common-header" },
      [
        _c("common-header", {
          attrs: {
            headerList: [
              { label: "系统管理", url: "" },
              { label: "用户群组管理", url: "" }
            ]
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "power-top" },
      [
        _c("search-form", {
          attrs: { formData: _vm.searchFormData, btnType: _vm.btnType },
          on: {
            searchForm: _vm.searchForm,
            resetForm: _vm.resetForm,
            addTable: function($event) {
              return _vm.goToEdit()
            }
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "power-table" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            ref: "multipleTable",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              "highlight-current-row": "",
              "tooltip-effect": "dark",
              height: _vm.tableheight,
              border: ""
            },
            on: {
              "header-dragend": _vm.headerdragend,
              "selection-change": _vm.handleSelectionChange
            }
          },
          [
            _c("template", { slot: "empty" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "center"
                  }
                },
                [_c("no-data", { attrs: { height: "400px", width: "400px" } })],
                1
              )
            ]),
            _c("el-table-column", {
              attrs: {
                prop: "systemName",
                label: "用户群组名称",
                "min-width": "80"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: { effect: "dark", placement: "top" }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "content" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.ToBreak(scope.row.userGroupName)
                              )
                            },
                            slot: "content"
                          }),
                          _c("div", { staticClass: "line" }, [
                            _vm._v(_vm._s(scope.row.userGroupName))
                          ])
                        ]
                      )
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: {
                prop: "permissionId",
                label: "创建时间",
                "min-width": "80"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: { effect: "dark", placement: "top" }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "content" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.ToBreak(scope.row.createdTime)
                              )
                            },
                            slot: "content"
                          }),
                          _c("div", { staticClass: "line" }, [
                            _vm._v(_vm._s(scope.row.createdTime))
                          ])
                        ]
                      )
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: {
                prop: "permissionName",
                label: "创建人",
                "min-width": "80"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: { effect: "dark", placement: "top" }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "content" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.ToBreak(scope.row.createdByName)
                              )
                            },
                            slot: "content"
                          }),
                          _c("div", { staticClass: "line" }, [
                            _vm._v(_vm._s(scope.row.createdByName))
                          ])
                        ]
                      )
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: {
                prop: "permissionDesc",
                "min-width": "80",
                label: "最后更新时间"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: { effect: "dark", placement: "top" }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "content" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.ToBreak(scope.row.updatedTime)
                              )
                            },
                            slot: "content"
                          }),
                          _c("div", { staticClass: "line" }, [
                            _vm._v(_vm._s(scope.row.updatedTime))
                          ])
                        ]
                      )
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: { label: "操作", width: "60", fixed: "right" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-popover",
                        {
                          ref: "power-" + scope.row.id,
                          attrs: {
                            placement: "right",
                            width: "190",
                            trigger: "click",
                            "popper-class": "table-popper"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "op-tips" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "op-item",
                                  on: {
                                    click: function($event) {
                                      return _vm.goToDetail(scope.row)
                                    }
                                  }
                                },
                                [
                                  _c("operate-power-icon", {
                                    staticClass: "svgOperateIcon"
                                  }),
                                  _vm._v(" 查看 ")
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "op-item",
                                  on: {
                                    click: function($event) {
                                      return _vm.goToEdit(scope.row)
                                    }
                                  }
                                },
                                [
                                  _c("operate-edit-icon", {
                                    staticClass: "svgOperateIcon"
                                  }),
                                  _vm._v(" 编辑 ")
                                ],
                                1
                              ),
                              _c(
                                "el-popconfirm",
                                {
                                  attrs: { title: "确定删除此用户组吗？" },
                                  on: {
                                    confirm: function($event) {
                                      return _vm.delUserGroup(scope.row)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "op-item",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _c("delIcon", {
                                        staticClass: "svgOperateIcon"
                                      }),
                                      _vm._v(" 删除 ")
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("operate", {
                            staticClass: "operate-icon",
                            attrs: { slot: "reference" },
                            slot: "reference"
                          })
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            })
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "power-footer" },
          [
            _vm.pageshow
              ? _c("el-pagination", {
                  attrs: {
                    background: "",
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.totalrecord,
                    "hide-on-single-page": false,
                    "page-sizes": [10, 20, 50, 100, 1000, 2000],
                    "page-size": 10,
                    "current-page": _vm.filtratedata.pageNum
                  },
                  on: {
                    "update:currentPage": function($event) {
                      return _vm.$set(_vm.filtratedata, "pageNum", $event)
                    },
                    "update:current-page": function($event) {
                      return _vm.$set(_vm.filtratedata, "pageNum", $event)
                    },
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }